export default "__VITE_ASSET__C3OmepCk__"